export default "__VITE_ASSET__C$5qnO1o__"